import { useNavigate } from 'react-router-dom'
import { Plus, Shield } from 'lucide-react'
import { PageShell } from '@/components/common/PageShell'
import { WorkspaceToolbar } from '@/components/common/WorkspaceToolbar'
import { useRoles } from '../hooks/useRoles'
import { Button } from '@/components/ui'
import { PermissionGate } from '@/components/common/PermissionGate'
import { RoleList } from './RoleList'

export function RolesPage(): React.ReactElement {
  const navigate = useNavigate()
  const { data: roles = [], isLoading, error, refetch } = useRoles()

  return (
    <PageShell
      breadcrumbItems={[
        { label: 'Organization', to: '/dashboard' },
        { label: 'Roles' },
      ]}
      icon={Shield}
      title="Roles"
      description="Configure roles for your organization."
      className="gap-0"
      hideHeader
    >
      <div className="space-y-4">
        <WorkspaceToolbar
          actions={
            <PermissionGate module="roles" action="create">
              <Button
                type="button"
                variant="primary"
                size="sm"
                onClick={() => navigate('/roles/new')}
              >
                <Plus className="h-4 w-4 shrink-0" aria-hidden />
                <span className="ml-1.5">Create New Role</span>
              </Button>
            </PermissionGate>
          }
        />

        <section>
          <h2 className="mb-3 text-base font-semibold text-gray-900 dark:text-gray-100">
            All roles
          </h2>
          <RoleList roles={roles} isLoading={isLoading} error={error} onRetry={refetch} />
        </section>
      </div>
    </PageShell>
  )
}

RolesPage.displayName = 'RolesPage'
